import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {Experience} from '../_models/experience';
import {ProductFilter} from '../_models/product-filter';


@Injectable({
  providedIn: 'root'
})
export class ProductService {


  constructor(private http: HttpClient) {
  }

  loadStandardProducts(productFilter: ProductFilter, page = 1) {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };
    var locality = productFilter.locality.join(',');
    var params = {
      product_type: 'STANDARD', sub_locality: locality, price_ranges: productFilter.priceRange.join(','),
      sort_by: productFilter.soryBy, city_id: productFilter.city, category: productFilter.category, merchant: productFilter.merchant
    };
    return this.http.post<any>(`${environment.domain}/api/products/standard/search/${productFilter.city}?page=${page}`, params, httpOptions);
  }

  loadStandardFilter(city: String) {
    return this.http.get<any>(`${environment.domain}/api/product/filters/standard/${city}`);
  }

  searchExperiences(city: String, keyword: string, page: number = 1) {
    return this.http.get<any>(`${environment.domain}/api/${city}/standard/search/${keyword}?page=${page}`);
  }

  searchExclusive(city: String, keyword: string, page: number = 1) {
    return this.http.get<any>(`${environment.domain}/api/${city}/experience/search/${keyword}?page=${page}`);
  }
}
